import { useEffect, useState } from 'react';
import type { IService } from '../../../../interfaces/service';
import type { ICustomControlProcedureDiagnosticReportReadProps } from '../../interfaces/';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { RequestStatus } from '../../../../../../common/enums/requestStatus';
import { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { ServiceType } from '../../../../../../common/enums/serviceType';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { fetchJson } from '../../../../../store/fetch';
import { translateKey } from '../../../../../translate';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemFooter } from '../../../episodes/ProcessItemFooter';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { OrthCV1RequestReadInner } from './OrthCV1RequestReadInner';

export function OrthCV1RequestReadForOrthO(props: ICustomControlProcedureDiagnosticReportReadProps) {
    const [isConsultOpen, setIsConsultOpen] = useState(false);
    const [orthCService, setOrthCService] = useState<IService | null>(null);

    useEffect(() => {
        loadOrthCService();
    }, []);

    if (
        props.request.status === RequestStatus.completed ||
        !orthCService ||
        !props.procedure.customControlData.consult
    ) {
        return null;
    }

    return (
        <ProcessContainer isActiveActivity={props.itemState.initialIsOpen}>
            <ProcessItemHeader
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={isConsultOpen}
                onToggle={(isOpened) => setIsConsultOpen(isOpened)}
                organizationName={props.process.recipientOrganization?.name}
                practitionerName={
                    props.process.recipientPractitioner
                        ? getDisplayName(props.process.recipientPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={ServiceType.consultation}
                showProcessIcon
                title={getServiceLabel(orthCService.code, 'request', orthCService.name)}
            />

            <OrthCV1RequestReadInner
                isOpen={isConsultOpen}
                onToggle={(isOpened) => setIsConsultOpen(isOpened)}
                orthCRequestReadData={{
                    question: props.procedure.customControlData.consult.question,
                    toelichting: props.procedure.customControlData.consult.toelichting,
                }}
            />

            {(props.procedure.customControlData.consult.question ||
                props.procedure.customControlData.consult.toelichting) && (
                <ProcessItemFooter
                    isItemOpen={isConsultOpen}
                    labelLess={translateKey('request.hideConsult')}
                    labelMore={translateKey('request.showConsult')}
                    onToggle={(isOpened) => setIsConsultOpen(isOpened)}
                />
            )}
        </ProcessContainer>
    );

    async function loadOrthCService() {
        const result = await fetchJson(`api/services?code=${ServiceCode.OrthC}`, 'GET');
        if (result.json.items) {
            setOrthCService(result.json.items[0]);
        } else {
            throw new Error('Cannot find OrthC service');
        }
    }
}
